import { createNanoEvents } from 'nanoevents';

const emitter = createNanoEvents();
let requestCount = 0;
let loadingStartTime = 0; // Czas (timestamp), kiedy loading się zaczął
let hideTimeoutId = null; // ID timera do ukrywania

// --- NOWOŚĆ --- Minimalny czas wyświetlania w milisekundach
const MIN_DISPLAY_TIME = 500; // 0.5 sekundy - możesz dostosować

// Request bez odpowiedzi (zerwana sieć) nie może zablokować ekranu spinnerem na zawsze —
// axios nie ma tu timeoutu. Po tym czasie spinner schodzi, request dalej może się skończyć.
const MAX_DISPLAY_TIME = 30000;
let watchdogId = null;

const loadingService = {
  show: () => {
    // Anuluj ewentualny zaplanowany timeout ukrycia, jeśli nowy request się zaczyna
    if (hideTimeoutId) {
      clearTimeout(hideTimeoutId);
      hideTimeoutId = null;
    }

    if (requestCount === 0) {
      loadingStartTime = Date.now(); // Zapisz czas startu tylko przy pierwszym zapytaniu
      emitter.emit('loading', true);
      watchdogId = setTimeout(() => {
        requestCount = 0;
        watchdogId = null;
        emitter.emit('loading', false);
      }, MAX_DISPLAY_TIME);
    }
    requestCount++;
  },

  hide: () => {
    requestCount--;
    if (requestCount < 0) {
      requestCount = 0; // Zabezpieczenie
    }

    if (requestCount === 0) {
      if (watchdogId) {
        clearTimeout(watchdogId);
        watchdogId = null;
      }
      const currentTime = Date.now();
      const elapsedTime = currentTime - loadingStartTime;
      const timeToWait = MIN_DISPLAY_TIME - elapsedTime;

      if (timeToWait > 0) {
        // Jeśli minęło za mało czasu, zaplanuj ukrycie na później
        hideTimeoutId = setTimeout(() => {
          // Dodatkowe sprawdzenie, czy w międzyczasie nie pojawił się nowy request
          if (requestCount === 0) { 
             emitter.emit('loading', false);
          }
          hideTimeoutId = null; // Wyzeruj ID po wykonaniu
        }, timeToWait);
      } else {
        // Jeśli minęło wystarczająco dużo czasu, ukryj od razu
        emitter.emit('loading', false);
      }
    }
  },

  onChange: (callback) => {
    return emitter.on('loading', callback);
  },
};

export default loadingService;